(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './androidx-navigationevent-navigationevent.js', './compose-multiplatform-core-compose-ui-ui.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-navigationevent-navigationevent.js'), require('./compose-multiplatform-core-compose-ui-ui.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigationevent-navigationevent-compose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-navigationevent-navigationevent-compose'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigationevent-navigationevent-compose'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-navigationevent-navigationevent-compose'.");
    }
    if (typeof globalThis['androidx-navigationevent-navigationevent'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigationevent-navigationevent-compose'. Its dependency 'androidx-navigationevent-navigationevent' was not found. Please, check whether 'androidx-navigationevent-navigationevent' is loaded prior to 'compose-multiplatform-core-navigationevent-navigationevent-compose'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigationevent-navigationevent-compose'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-navigationevent-navigationevent-compose'.");
    }
    globalThis['compose-multiplatform-core-navigationevent-navigationevent-compose'] = factory(typeof globalThis['compose-multiplatform-core-navigationevent-navigationevent-compose'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-navigationevent-navigationevent-compose'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-navigationevent-navigationevent'], globalThis['compose-multiplatform-core-compose-ui-ui']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_navigationevent_navigationevent, kotlin_org_jetbrains_compose_ui_ui) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var NavigationEventHandler = kotlin_androidx_navigationevent_navigationevent.$_$.a;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var emptyList = kotlin_kotlin.$_$.c9;
  var Idle_getInstance = kotlin_androidx_navigationevent_navigationevent.$_$.f;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var findDefaultNavigationEventDispatcherOwner = kotlin_org_jetbrains_compose_ui_ui.$_$.n7;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(LocalNavigationEventDispatcherOwner, 'LocalNavigationEventDispatcherOwner');
  initMetadataForClass(ComposeNavigationEventHandler, 'ComposeNavigationEventHandler', VOID, NavigationEventHandler);
  initMetadataForClass(NavigationEventHandler$$inlined$cache$7$1);
  initMetadataForClass(NavigationEventState, 'NavigationEventState');
  //endregion
  var androidx_navigationevent_compose_LocalNavigationEventDispatcherOwner$stable;
  function LocalNavigationEventDispatcherOwner$LocalNavigationEventDispatcherOwner$lambda() {
    return null;
  }
  function LocalNavigationEventDispatcherOwner() {
    LocalNavigationEventDispatcherOwner_instance = this;
    var tmp = this;
    tmp.axp_1 = compositionLocalOf(VOID, LocalNavigationEventDispatcherOwner$LocalNavigationEventDispatcherOwner$lambda);
  }
  protoOf(LocalNavigationEventDispatcherOwner).zxk = function ($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -942026292, 'C(<get-current>)38@1631L7:LocalNavigationEventDispatcherOwner.kt#wc8b4r');
    if (isTraceInProgress()) {
      traceEventStart(-942026292, $changed, -1, 'androidx.navigationevent.compose.LocalNavigationEventDispatcherOwner.<get-current> (LocalNavigationEventDispatcherOwner.kt:38)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = this.axp_1;
    var $composer_1 = $composer_0;
    var tmp0_elvis_lhs = $composer_1.u31(this_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      $composer_0.m30(950836184);
      sourceInformation($composer_0, '39@1658L44');
      var tmp1_group = findViewTreeNavigationEventDispatcherOwner($composer_0, 0);
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(950834231);
      $composer_0.n30();
      tmp = tmp0_elvis_lhs;
    }
    var tmp0 = tmp;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  var LocalNavigationEventDispatcherOwner_instance;
  function LocalNavigationEventDispatcherOwner_getInstance() {
    if (LocalNavigationEventDispatcherOwner_instance == null)
      new LocalNavigationEventDispatcherOwner();
    return LocalNavigationEventDispatcherOwner_instance;
  }
  function NavigationBackHandler(state, isBackEnabled, onBackCancelled, onBackCompleted, $composer, $changed, $default) {
    var isBackEnabled_0 = {_v: isBackEnabled};
    var onBackCancelled_0 = {_v: onBackCancelled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1220469155);
    sourceInformation($composer_0, 'C(NavigationBackHandler)P(3)150@6741L2,155@6862L2,156@6895L2,153@6786L296:NavigationEventHandler.kt#wc8b4r');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isBackEnabled_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onBackCancelled_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onBackCompleted) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        isBackEnabled_0._v = true;
      }
      if (!(($default & 4) === 0)) {
        sourceInformationMarkerStart($composer_0, 344791077, 'CC(remember):NavigationEventHandler.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = NavigationBackHandler$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onBackCancelled_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(1220469155, $dirty, -1, 'androidx.navigationevent.compose.NavigationBackHandler (NavigationEventHandler.kt:152)');
      }
      sourceInformationMarkerStart($composer_0, 344794949, 'CC(remember):NavigationEventHandler.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = NavigationBackHandler$lambda_0;
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, 344796005, 'CC(remember):NavigationEventHandler.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = NavigationBackHandler$lambda_1;
        this_2.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      NavigationEventHandler_0(state, false, tmp1_group, tmp2_group, isBackEnabled_0._v, onBackCancelled_0._v, onBackCompleted, $composer_0, 3504 | 14 & $dirty | 57344 & $dirty << 9 | 458752 & $dirty << 9 | 3670016 & $dirty << 9, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(NavigationBackHandler$lambda_2(state, isBackEnabled_0, onBackCancelled_0, onBackCompleted, $changed, $default));
    }
  }
  function NavigationEventHandler_0(state, isForwardEnabled, onForwardCancelled, onForwardCompleted, isBackEnabled, onBackCancelled, onBackCompleted, $composer, $changed, $default) {
    var isForwardEnabled_0 = {_v: isForwardEnabled};
    var onForwardCancelled_0 = {_v: onForwardCancelled};
    var onForwardCompleted_0 = {_v: onForwardCompleted};
    var isBackEnabled_0 = {_v: isBackEnabled};
    var onBackCancelled_0 = {_v: onBackCancelled};
    var onBackCompleted_0 = {_v: onBackCompleted};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(898330592);
    sourceInformation($composer_0, 'C(NavigationEventHandler)P(6,1,4,5)73@3839L2,74@3880L2,77@3982L2,78@4020L2,80@4036L18,87@4356L7,93@4553L276,102@4846L467,102@4835L478,114@5343L373,114@5319L397:NavigationEventHandler.kt#wc8b4r');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(state) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isForwardEnabled_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onForwardCancelled_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onForwardCompleted_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(isBackEnabled_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onBackCancelled_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onBackCompleted_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        isForwardEnabled_0._v = true;
      }
      if (!(($default & 4) === 0)) {
        sourceInformationMarkerStart($composer_0, 7278594, 'CC(remember):NavigationEventHandler.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = NavigationEventHandler$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onForwardCancelled_0._v = tmp0_group;
      }
      if (!(($default & 8) === 0)) {
        sourceInformationMarkerStart($composer_0, 7279906, 'CC(remember):NavigationEventHandler.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_0 = this_1.i31();
        var tmp_0;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = NavigationEventHandler$lambda_0;
          this_1.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        var tmp1_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        onForwardCompleted_0._v = tmp1_group;
      }
      if (!(($default & 16) === 0)) {
        isBackEnabled_0._v = true;
      }
      if (!(($default & 32) === 0)) {
        sourceInformationMarkerStart($composer_0, 7283170, 'CC(remember):NavigationEventHandler.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_1 = this_2.i31();
        var tmp_1;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = NavigationEventHandler$lambda_1;
          this_2.j31(value_1);
          tmp_1 = value_1;
        } else {
          tmp_1 = it_1;
        }
        var tmp2_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        onBackCancelled_0._v = tmp2_group;
      }
      if (!(($default & 64) === 0)) {
        sourceInformationMarkerStart($composer_0, 7284386, 'CC(remember):NavigationEventHandler.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_3 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_2 = this_3.i31();
        var tmp_2;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = NavigationEventHandler$lambda_2;
          this_3.j31(value_2);
          tmp_2 = value_2;
        } else {
          tmp_2 = it_2;
        }
        var tmp3_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        onBackCompleted_0._v = tmp3_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(898330592, $dirty, -1, 'androidx.navigationevent.compose.NavigationEventHandler (NavigationEventHandler.kt:79)');
      }
      if (isInspectionMode($composer_0, 0)) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp7_safe_receiver = $composer_0.t30();
        if (tmp7_safe_receiver == null)
          null;
        else {
          tmp7_safe_receiver.p3c(NavigationEventHandler$lambda_3(state, isForwardEnabled_0, onForwardCancelled_0, onForwardCompleted_0, isBackEnabled_0, onBackCancelled_0, onBackCompleted_0, $changed, $default));
        }
        return Unit_instance;
      }
      var tmp0 = LocalNavigationEventDispatcherOwner_getInstance().zxk($composer_0, 6);
      var tmp$ret$16;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'No NavigationEventDispatcher was provided via LocalNavigationEventDispatcherOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp$ret$16 = tmp0;
          break $l$block;
        }
      }
      var dispatcher = tmp$ret$16.p8s();
      sourceInformationMarkerStart($composer_0, 7301716, 'CC(remember):NavigationEventHandler.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_0.i31();
      var tmp_3;
      if (invalid || it_3 === Companion_getInstance().f30_1) {
        var tmp_4 = state.alf();
        var value_3 = new ComposeNavigationEventHandler(tmp_4, NavigationEventHandler$lambda_4(state));
        tmp0_0.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var tmp4_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var sourceHandler = tmp4_group;
      sourceInformationMarkerStart($composer_0, 7311283, 'CC(remember):NavigationEventHandler.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!(!!(!!(!!($composer_0.q31(sourceHandler) | ($dirty & 112) === 32) | ($dirty & 896) === 256) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384) | ($dirty & 458752) === 131072) | ($dirty & 3670016) === 1048576) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_1.i31();
      var tmp_5;
      if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = NavigationEventHandler$lambda_5(sourceHandler, isForwardEnabled_0, onForwardCancelled_0, onForwardCompleted_0, isBackEnabled_0, onBackCancelled_0, onBackCompleted_0, state);
        tmp0_1.j31(value_4);
        tmp_5 = value_4;
      } else {
        tmp_5 = it_4;
      }
      var tmp5_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      SideEffect(tmp5_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, 7327093, 'CC(remember):NavigationEventHandler.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!(($dirty & 14) === 4 | $composer_0.q31(sourceHandler)) | $composer_0.q31(dispatcher));
      // Inline function 'kotlin.let' call
      var it_5 = tmp0_2.i31();
      var tmp_6;
      if (invalid_1 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = NavigationEventHandler$lambda_6(state, sourceHandler, dispatcher);
        tmp0_2.j31(value_5);
        tmp_6 = value_5;
      } else {
        tmp_6 = it_5;
      }
      var tmp6_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      DisposableEffect(state, tmp6_group, $composer_0, 14 & $dirty);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp8_safe_receiver = $composer_0.t30();
    if (tmp8_safe_receiver == null)
      null;
    else {
      tmp8_safe_receiver.p3c(NavigationEventHandler$lambda_7(state, isForwardEnabled_0, onForwardCancelled_0, onForwardCompleted_0, isBackEnabled_0, onBackCancelled_0, onBackCompleted_0, $changed, $default));
    }
  }
  function ComposeNavigationEventHandler$_init_$lambda_jleudx(it) {
    return Unit_instance;
  }
  function ComposeNavigationEventHandler$currentOnForwardCancelled$lambda() {
    return Unit_instance;
  }
  function ComposeNavigationEventHandler$currentOnForwardCompleted$lambda() {
    return Unit_instance;
  }
  function ComposeNavigationEventHandler$currentOnBackCancelled$lambda() {
    return Unit_instance;
  }
  function ComposeNavigationEventHandler$currentOnBackCompleted$lambda() {
    return Unit_instance;
  }
  function ComposeNavigationEventHandler(initialInfo, onTransitionStateChanged) {
    var tmp;
    if (onTransitionStateChanged === VOID) {
      tmp = ComposeNavigationEventHandler$_init_$lambda_jleudx;
    } else {
      tmp = onTransitionStateChanged;
    }
    onTransitionStateChanged = tmp;
    NavigationEventHandler.call(this, initialInfo, false, false);
    this.nxp_1 = onTransitionStateChanged;
    var tmp_0 = this;
    tmp_0.oxp_1 = ComposeNavigationEventHandler$currentOnForwardCancelled$lambda;
    var tmp_1 = this;
    tmp_1.pxp_1 = ComposeNavigationEventHandler$currentOnForwardCompleted$lambda;
    var tmp_2 = this;
    tmp_2.qxp_1 = ComposeNavigationEventHandler$currentOnBackCancelled$lambda;
    var tmp_3 = this;
    tmp_3.rxp_1 = ComposeNavigationEventHandler$currentOnBackCompleted$lambda;
  }
  protoOf(ComposeNavigationEventHandler).a8p = function (event) {
    this.nxp_1(this.i8o_1);
  };
  protoOf(ComposeNavigationEventHandler).e8p = function () {
    this.nxp_1(this.i8o_1);
    this.oxp_1();
  };
  protoOf(ComposeNavigationEventHandler).c8p = function () {
    this.nxp_1(this.i8o_1);
    this.pxp_1();
  };
  protoOf(ComposeNavigationEventHandler).u8o = function (event) {
    this.nxp_1(this.i8o_1);
  };
  protoOf(ComposeNavigationEventHandler).y8o = function () {
    this.nxp_1(this.i8o_1);
    this.qxp_1();
  };
  protoOf(ComposeNavigationEventHandler).w8o = function () {
    this.nxp_1(this.i8o_1);
    this.rxp_1();
  };
  function NavigationBackHandler$lambda() {
    return Unit_instance;
  }
  function NavigationBackHandler$lambda_0() {
    return Unit_instance;
  }
  function NavigationBackHandler$lambda_1() {
    return Unit_instance;
  }
  function NavigationBackHandler$lambda_2($state, $isBackEnabled, $onBackCancelled, $onBackCompleted, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationBackHandler($state, $isBackEnabled._v, $onBackCancelled._v, $onBackCompleted, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationEventHandler$lambda() {
    return Unit_instance;
  }
  function NavigationEventHandler$lambda_0() {
    return Unit_instance;
  }
  function NavigationEventHandler$lambda_1() {
    return Unit_instance;
  }
  function NavigationEventHandler$lambda_2() {
    return Unit_instance;
  }
  function NavigationEventHandler$lambda_3($state, $isForwardEnabled, $onForwardCancelled, $onForwardCompleted, $isBackEnabled, $onBackCancelled, $onBackCompleted, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationEventHandler_0($state, $isForwardEnabled._v, $onForwardCancelled._v, $onForwardCompleted._v, $isBackEnabled._v, $onBackCancelled._v, $onBackCompleted._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationEventHandler$lambda_4($state) {
    return function (transitionState) {
      $state.sxp(transitionState);
      return Unit_instance;
    };
  }
  function NavigationEventHandler$lambda_5($sourceHandler, $isForwardEnabled, $onForwardCancelled, $onForwardCompleted, $isBackEnabled, $onBackCancelled, $onBackCompleted, $state) {
    return function () {
      $sourceHandler.p8o($isForwardEnabled._v);
      $sourceHandler.oxp_1 = $onForwardCancelled._v;
      $sourceHandler.pxp_1 = $onForwardCompleted._v;
      $sourceHandler.m8o($isBackEnabled._v);
      $sourceHandler.qxp_1 = $onBackCancelled._v;
      $sourceHandler.rxp_1 = $onBackCompleted._v;
      $sourceHandler.r8o($state.alf(), $state.txp(), $state.uxp());
      return Unit_instance;
    };
  }
  function NavigationEventHandler$$inlined$cache$7$1($sourceHandler, $state) {
    this.vxp_1 = $sourceHandler;
    this.wxp_1 = $state;
  }
  protoOf(NavigationEventHandler$$inlined$cache$7$1).s1d = function () {
    this.vxp_1.l4();
    this.wxp_1.fxp_1 = null;
  };
  function NavigationEventHandler$lambda_6($state, $sourceHandler, $dispatcher) {
    return function ($this$DisposableEffect) {
      // Inline function 'kotlin.require' call
      if (!($state.fxp_1 == null)) {
        var message = "NavigationEventState '" + toString($state) + "' is already registered with a NavigationEventHandler '" + toString($sourceHandler) + "'.";
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      $state.fxp_1 = $sourceHandler;
      $dispatcher.w8n($sourceHandler);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new NavigationEventHandler$$inlined$cache$7$1($sourceHandler, $state);
    };
  }
  function NavigationEventHandler$lambda_7($state, $isForwardEnabled, $onForwardCancelled, $onForwardCompleted, $isBackEnabled, $onBackCancelled, $onBackCompleted, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationEventHandler_0($state, $isForwardEnabled._v, $onForwardCancelled._v, $onForwardCompleted._v, $isBackEnabled._v, $onBackCancelled._v, $onBackCompleted._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var androidx_navigationevent_compose_NavigationEventState$stable;
  function NavigationEventState$_get_transitionState_$ref_i5n9kl() {
    return constructCallableReference(function (p0) {
      return p0.xxp();
    }, 1, 0, 523);
  }
  function NavigationEventState$_set_transitionState_$ref_vgdigx() {
    return constructCallableReference(function (p0, p1) {
      p0.sxp(p1);
      return Unit_instance;
    }, 2, 0, 524);
  }
  function NavigationEventState$_get_backInfo_$ref_1gwflu() {
    return constructCallableReference(function (p0) {
      return p0.txp();
    }, 1, 0, 525);
  }
  function NavigationEventState$_set_backInfo_$ref_h0n65y() {
    return constructCallableReference(function (p0, p1) {
      p0.yxp(p1);
      return Unit_instance;
    }, 2, 0, 526);
  }
  function NavigationEventState$_get_currentInfo_$ref_qga7z4() {
    return constructCallableReference(function (p0) {
      return p0.alf();
    }, 1, 0, 527);
  }
  function NavigationEventState$_set_currentInfo_$ref_yh3mhg() {
    return constructCallableReference(function (p0, p1) {
      p0.zxp(p1);
      return Unit_instance;
    }, 2, 0, 528);
  }
  function NavigationEventState$_get_forwardInfo_$ref_gxc3os() {
    return constructCallableReference(function (p0) {
      return p0.uxp();
    }, 1, 0, 529);
  }
  function NavigationEventState$_set_forwardInfo_$ref_r12b7c() {
    return constructCallableReference(function (p0, p1) {
      p0.axq(p1);
      return Unit_instance;
    }, 2, 0, 530);
  }
  function NavigationEventState(currentInfo, backInfo, forwardInfo) {
    backInfo = backInfo === VOID ? emptyList() : backInfo;
    forwardInfo = forwardInfo === VOID ? emptyList() : forwardInfo;
    this.bxp_1 = mutableStateOf(Idle_getInstance());
    this.cxp_1 = mutableStateOf(backInfo);
    this.dxp_1 = mutableStateOf(currentInfo);
    this.exp_1 = mutableStateOf(forwardInfo);
    this.fxp_1 = null;
  }
  protoOf(NavigationEventState).sxp = function (_set____db54di) {
    var tmp0 = this.bxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_transitionState_$ref_i5n9kl();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('transitionState', 1, tmp, tmp_0, NavigationEventState$_set_transitionState_$ref_vgdigx());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(NavigationEventState).xxp = function () {
    var tmp0 = this.bxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_transitionState_$ref_i5n9kl();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('transitionState', 1, tmp, tmp_0, NavigationEventState$_set_transitionState_$ref_vgdigx());
    return tmp0.u1();
  };
  protoOf(NavigationEventState).yxp = function (_set____db54di) {
    var tmp0 = this.cxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_backInfo_$ref_1gwflu();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('backInfo', 1, tmp, tmp_0, NavigationEventState$_set_backInfo_$ref_h0n65y());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(NavigationEventState).txp = function () {
    var tmp0 = this.cxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_backInfo_$ref_1gwflu();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('backInfo', 1, tmp, tmp_0, NavigationEventState$_set_backInfo_$ref_h0n65y());
    return tmp0.u1();
  };
  protoOf(NavigationEventState).zxp = function (_set____db54di) {
    var tmp0 = this.dxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_currentInfo_$ref_qga7z4();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('currentInfo', 1, tmp, tmp_0, NavigationEventState$_set_currentInfo_$ref_yh3mhg());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(NavigationEventState).alf = function () {
    var tmp0 = this.dxp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_currentInfo_$ref_qga7z4();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentInfo', 1, tmp, tmp_0, NavigationEventState$_set_currentInfo_$ref_yh3mhg());
    return tmp0.u1();
  };
  protoOf(NavigationEventState).axq = function (_set____db54di) {
    var tmp0 = this.exp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_forwardInfo_$ref_gxc3os();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('forwardInfo', 1, tmp, tmp_0, NavigationEventState$_set_forwardInfo_$ref_r12b7c());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(NavigationEventState).uxp = function () {
    var tmp0 = this.exp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = NavigationEventState$_get_forwardInfo_$ref_gxc3os();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('forwardInfo', 1, tmp, tmp_0, NavigationEventState$_set_forwardInfo_$ref_r12b7c());
    return tmp0.u1();
  };
  function rememberNavigationEventState(currentInfo, backInfo, forwardInfo, $composer, $changed, $default) {
    var backInfo_0 = {_v: backInfo};
    var forwardInfo_0 = {_v: forwardInfo};
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 116613162, 'C(rememberNavigationEventState)P(1)45@1902L69,46@1987L121,46@1976L132:RememberNavigationEventState.kt#wc8b4r');
    if (!(($default & 2) === 0)) {
      backInfo_0._v = emptyList();
    }
    if (!(($default & 4) === 0)) {
      forwardInfo_0._v = emptyList();
    }
    if (isTraceInProgress()) {
      traceEventStart(116613162, $changed, -1, 'androidx.navigationevent.compose.rememberNavigationEventState (RememberNavigationEventState.kt:44)');
    }
    sourceInformationMarkerStart($composer_0, 396105519, 'CC(remember):RememberNavigationEventState.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new NavigationEventState(currentInfo, backInfo_0._v, forwardInfo_0._v);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    var state = tmp1_group;
    sourceInformationMarkerStart($composer_0, 396108291, 'CC(remember):RememberNavigationEventState.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.q31(currentInfo) || ($changed & 6) === 4) | $composer_0.q31(backInfo_0._v)) | $composer_0.q31(forwardInfo_0._v));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = rememberNavigationEventState$lambda(state, currentInfo, backInfo_0, forwardInfo_0);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp2_group = tmp_0;
    sourceInformationMarkerEnd($composer_0);
    SideEffect(tmp2_group, $composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return state;
  }
  function rememberNavigationEventState$lambda($state, $currentInfo, $backInfo, $forwardInfo) {
    return function () {
      $state.zxp($currentInfo);
      $state.yxp($backInfo._v);
      $state.axq($forwardInfo._v);
      return Unit_instance;
    };
  }
  function findViewTreeNavigationEventDispatcherOwner($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 916565848, 'C(findViewTreeNavigationEventDispatcherOwner)26@1045L43:LocalNavigationEventDispatcherOwner.nonAndroid.kt#wc8b4r');
    if (isTraceInProgress()) {
      traceEventStart(916565848, $changed, -1, 'androidx.navigationevent.compose.findViewTreeNavigationEventDispatcherOwner (LocalNavigationEventDispatcherOwner.nonAndroid.kt:26)');
    }
    var tmp0 = findDefaultNavigationEventDispatcherOwner($composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function isInspectionMode($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 654440778, 'C(isInspectionMode):NavigationEventHandler.nonAndroid.kt#wc8b4r');
    if (isTraceInProgress()) {
      traceEventStart(654440778, $changed, -1, 'androidx.navigationevent.compose.isInspectionMode (NavigationEventHandler.nonAndroid.kt:21)');
    }
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return false;
  }
  //region block: init
  androidx_navigationevent_compose_LocalNavigationEventDispatcherOwner$stable = 0;
  androidx_navigationevent_compose_NavigationEventState$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = NavigationBackHandler;
  _.$_$.b = rememberNavigationEventState;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-navigationevent-navigationevent-compose.js.map
